<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>

    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList" />
      <div class="dp-dept-hint">
        <span class="dp-dept-hint__label">所属机构</span>
        <span class="dp-dept-hint__value">{{ currentDepartmentName || "全部" }}</span>
      </div>
      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="listLoading" style="width: 100%" fit height="100%">
        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="contentTypeMap[scope.row.ContentType] ? contentTypeMap[scope.row.ContentType].type : 'info'" size="small">
              {{ contentTypeMap[scope.row.ContentType] ? contentTypeMap[scope.row.ContentType].label : scope.row.ContentType }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分类" width="76" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ContentCategory === 1" type="danger" size="small">违停</el-tag>
            <el-tag v-else type="info" size="small">普通</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="摘要" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getListSummary(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="校区" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getCampusName(scope.row.CampusId) }}
          </template>
        </el-table-column>
        <el-table-column label="审核" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="auditStatusMap[scope.row.AuditStatus] ? auditStatusMap[scope.row.AuditStatus].type : 'info'" size="small">
              {{ auditStatusMap[scope.row.AuditStatus] ? auditStatusMap[scope.row.AuditStatus].label : scope.row.AuditStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="启用" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsEnabled ? 'success' : 'info'" size="small">
              {{ scope.row.IsEnabled ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button type="text" size="small" class="table-op-link" @click="handleDetail(scope.row)">详情</el-button>
              <el-button
                v-if="scope.row.AuditStatus === 0"
                type="text"
                size="small"
                class="table-op-link"
                @click="handleAudit(scope.row, 1)"
              >通过</el-button>
              <el-button
                v-if="scope.row.AuditStatus === 0"
                type="text"
                size="small"
                class="table-op-link table-op-link--danger"
                @click="handleAudit(scope.row, 2)"
              >拒绝</el-button>
              <el-button
                v-if="scope.row.ContentType !== 3 && !(scope.row.ContentCategory === 1 && scope.row.AuditStatus === 1)"
                type="text"
                size="small"
                class="table-op-link"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="handleDel(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination layout="total,prev,pager,next" @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" :total="total" style="float: right" />
      </div>

      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        custom-class="screen-content-dialog"
        width="620px"
        :close-on-click-modal="false"
        destroy-on-close
        @closed="handleDialogClosed"
      >
        <el-form :model="temp" label-width="100px" :rules="rules" ref="dataForm">
          <el-form-item label="内容类型" prop="ContentType">
            <el-radio-group v-model="temp.ContentType" @change="handleContentTypeChange">
              <el-radio :label="1">图片</el-radio>
              <el-radio :label="2">文字</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="内容分类">
            <el-radio-group v-model="temp.ContentCategory" @change="handleContentCategoryChange">
              <el-radio :label="0">普通展示</el-radio>
              <el-radio :label="1">违停</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="所属校区" prop="CampusId" :required="temp.Id === 0">
            <el-select
              v-model="temp.CampusId"
              placeholder="请选择校区"
              style="width: 100%"
              clearable
              :disabled="temp.Id > 0"
              @change="onDialogCampusChange"
            >
              <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="toDeptId(c.Id)" />
            </el-select>
          </el-form-item>
          <template v-if="temp.ContentCategory === 1">
            <el-form-item label="车牌">
              <el-input
                v-model="temp.LicensePlate"
                maxlength="20"
                clearable
                placeholder="输入车牌后自动按监护人绑定车牌匹配学生"
                @input="onLicensePlateInput"
                @blur="onLicensePlateBlur"
              >
                <i v-if="plateLookupLoading" slot="suffix" class="el-input__icon el-icon-loading" />
              </el-input>
            </el-form-item>
            <el-form-item label="关联学生">
              <div class="ps-pick-summary">
                <span v-if="temp.RelatedStudentId">
                  已选 <strong>{{ relatedStudentLabel || ('学生#' + temp.RelatedStudentId) }}</strong>
                </span>
                <span v-else class="muted-text">请选择一名学生</span>
                <el-button type="primary" size="mini" plain @click="openRelatedStudentPicker">选择学生</el-button>
                <el-button v-if="temp.RelatedStudentId" type="text" size="mini" @click="clearRelatedStudent">清空</el-button>
              </div>
              <div class="form-hint">从通讯录选择，仅绑定一人；也可输入车牌自动匹配</div>
            </el-form-item>
            <el-form-item label="违停路段">
              <el-input v-model="temp.ViolationLocation" maxlength="200" clearable placeholder="选填" />
            </el-form-item>
            <el-form-item label="补充说明">
              <el-input
                v-model="temp.ExtraRemark"
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                clearable
                placeholder="选填，会追加到大屏文案"
              />
            </el-form-item>
          </template>
          <el-form-item v-if="temp.ContentType === 2 && temp.ContentCategory !== 1" label="文本内容" prop="TextContent">
            <el-input v-model="temp.TextContent" type="textarea" :rows="4" maxlength="2000" placeholder="请输入文字内容" />
          </el-form-item>
          <el-form-item v-if="temp.ContentType === 1" label="上传图片" prop="MediaUrl">
            <el-upload
              class="upload-demo"
              :key="'img_' + uploadRenderKey"
              action="#"
              :auto-upload="false"
              list-type="picture-card"
              :file-list="imageUploadFiles"
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :limit="1"
              :on-exceed="handleUploadExceed"
              accept=".png,.jpg,.jpeg,.gif,.bmp,.webp"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item v-if="temp.ContentType === 1 && temp.ContentCategory !== 1" label="附加说明" prop="TextContent">
            <el-input
              v-model="temp.TextContent"
              type="textarea"
              :rows="3"
              maxlength="2000"
              show-word-limit
              placeholder="选填，可与图片一起在屏上展示"
            />
          </el-form-item>
          <!-- 媒体URL改为隐藏，避免手工篡改地址导致资源无法访问 -->
          <el-form-item v-if="false" label="媒体URL" prop="MediaUrl">
            <el-input v-model="temp.MediaUrl" />
          </el-form-item>
          <el-form-item label="投放大屏">
            <el-switch v-model="temp.PublishToScreen" active-text="投放" inactive-text="不投放" />
            <div class="form-hint">投放范围按所属校区在「放学大屏配置」中设置；不选具体大屏。</div>
          </el-form-item>
          <el-form-item v-if="temp.Id === 0 && temp.ContentCategory !== 1" label="上传者" prop="UploaderId">
            <el-select v-model="temp.UploaderId" filterable placeholder="请选择上传教师" style="width: 100%" @change="handleUploaderChange">
              <el-option v-for="item in teacherOptions" :key="item.Id" :label="item.TeacherName" :value="item.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="显示排序" prop="DisplayOrder">
            <el-input-number v-model="temp.DisplayOrder" :min="0" controls-position="right" />
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="temp.IsEnabled" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="saveData" :loading="submitLoading">确认</el-button>
        </div>
      </el-dialog>

      <person-scope-picker-dialog
        :visible.sync="relatedStudentPickerVisible"
        directory-scope="teaching"
        :show-scope-tabs="false"
        :scope-department-id="schoolDepartmentId"
        :value="temp.RelatedStudentId"
        :label="relatedStudentLabel"
        title="选择关联学生"
        @confirm="onRelatedStudentPicked"
      />

      <el-dialog
        title="内容详情"
        :visible.sync="detailVisible"
        width="640px"
        custom-class="screen-content-detail-dialog"
        append-to-body
        @closed="detailRow = null"
      >
        <template v-if="detailRow">
          <el-descriptions :column="2" size="small" border>
            <el-descriptions-item label="类型">
              {{ contentTypeMap[detailRow.ContentType] ? contentTypeMap[detailRow.ContentType].label : detailRow.ContentType }}
            </el-descriptions-item>
            <el-descriptions-item label="分类">
              <el-tag v-if="detailRow.ContentCategory === 1" type="danger" size="mini">违停</el-tag>
              <el-tag v-else type="info" size="mini">普通</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="校区">{{ getCampusName(detailRow.CampusId) }}</el-descriptions-item>
            <el-descriptions-item label="是否投放">{{ detailRow.PublishToScreen === false ? "不投放" : "投放" }}</el-descriptions-item>
            <el-descriptions-item label="展示大屏" :span="2">{{ detailRow.ScreenNames || (detailRow.PublishToScreen === false ? "-" : "按校区配置（全部或指定）") }}</el-descriptions-item>
            <el-descriptions-item label="审核状态">
              <el-tag :type="auditStatusMap[detailRow.AuditStatus] ? auditStatusMap[detailRow.AuditStatus].type : 'info'" size="mini">
                {{ auditStatusMap[detailRow.AuditStatus] ? auditStatusMap[detailRow.AuditStatus].label : detailRow.AuditStatus }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="启用">{{ detailRow.IsEnabled ? "是" : "否" }}</el-descriptions-item>
            <el-descriptions-item label="上传者">{{ detailRow.UploaderName || "-" }}</el-descriptions-item>
            <el-descriptions-item label="来源">{{ detailRow.UploadSource === 2 ? "后台" : "手机" }}</el-descriptions-item>
            <el-descriptions-item label="审核人">{{ detailRow.AuditorName || "-" }}</el-descriptions-item>
            <el-descriptions-item label="审核时间">{{ formatTime(detailRow.AuditTime) || "-" }}</el-descriptions-item>
            <el-descriptions-item label="排序">{{ detailRow.DisplayOrder }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ formatTime(detailRow.CreateTime) || "-" }}</el-descriptions-item>
          </el-descriptions>

          <template v-if="detailRow.ContentCategory === 1">
            <div class="detail-section-title">违停信息</div>
            <el-descriptions :column="2" size="small" border>
              <el-descriptions-item label="车牌">{{ detailRow.LicensePlate || "-" }}</el-descriptions-item>
              <el-descriptions-item label="学生">
                {{ detailRow.RelatedStudentName || (detailRow.RelatedStudentId ? detailRow.RelatedStudentId : "-") }}
              </el-descriptions-item>
              <el-descriptions-item label="路段" :span="2">{{ detailRow.ViolationLocation || "-" }}</el-descriptions-item>
              <el-descriptions-item label="展示截止" :span="2">{{ formatTime(detailRow.DisplayUntil) || "不限" }}</el-descriptions-item>
            </el-descriptions>
          </template>

          <div class="detail-section-title">展示内容</div>
          <div v-if="detailRow.ContentType === 1 && detailRow.MediaUrl" class="detail-media">
            <oss-el-image
              :src="detailRow.MediaUrl"
              :school-id="schoolDepartmentId"
              :preview-src-list="[detailRow.MediaUrl]"
              fit="contain"
              class="detail-media__img"
            />
          </div>
          <div v-if="detailRow.TextContent" class="detail-text">{{ detailRow.TextContent }}</div>
          <div v-else-if="detailRow.ContentType !== 1" class="detail-text detail-text--empty">无文字内容</div>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailVisible = false">关闭</el-button>
          <el-button
            v-if="detailRow && detailRow.ContentType !== 3 && !(detailRow.ContentCategory === 1 && detailRow.AuditStatus === 1)"
            type="primary"
            @click="openEditFromDetail"
          >编辑</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="视频预览"
        :visible.sync="videoPreviewVisible"
        width="640px"
        :close-on-click-modal="true"
        top="8vh"
      >
        <div class="video-dialog-wrap">
          <video
            v-if="videoPreviewUrl"
            class="video-dialog-player"
            :src="videoPreviewUrl"
            controls
            autoplay
            preload="metadata"
            playsinline
            webkit-playsinline
            x5-playsinline
          ></video>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getScreenContentList,
  saveScreenContent,
  deleteScreenContent,
  auditScreenContent,
  lookupStudentsByPlateForViolation
} from "@/api/dismissal";
import { getTeacherMasterList } from '../../api/modules/personnel';
import { BaseApiUrl } from '../../api/base';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";
import PersonScopePickerDialog from "../../components/PersonScopePickerDialog";
import { toDeptId, treeNodeDeptId, normalizeDeptId } from '../../utils/deptCascaderProps';

export default {
  name: "ScreenContentManage",
  components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      currentSchId: "",
      /** 左侧机构部门 Id（数字），用于拉校区列表 */
      schoolDepartmentId: 0,
      campusOptions: [],
      currentDepartmentName: "",
      searchList: [
        { label: "类型", key: "contentType", type: "select", options: [{ label: "全部", value: "" }, { label: "图片", value: 1 }, { label: "文字", value: 2 }] },
        { label: "分类", key: "contentCategory", type: "select", options: [{ label: "全部", value: "" }, { label: "普通", value: 0 }, { label: "违停", value: 1 }] },
        { label: "审核", key: "auditStatus", type: "select", options: [{ label: "全部", value: "" }, { label: "待审核", value: 0 }, { label: "已通过", value: 1 }, { label: "已拒绝", value: 2 }] },
        { label: "选择校区", key: "campusId", type: "select", clearable: true, initValue: null, options: [] }
      ],
      filters: {
        contentType: "",
        contentCategory: "",
        auditStatus: "",
        campusId: null
      },
      buttonList: [],
      dialogFormVisible: false,
      dialogTitle: "",
      detailVisible: false,
      detailRow: null,
      submitLoading: false,
      teacherOptions: [],
      /** 违停关联学生：通讯录单选。更新于 2026-09-23 */
      relatedStudentPickerVisible: false,
      relatedStudentLabel: "",
      BaseApiUrl: BaseApiUrl,
      imageUploadFiles: [],
      videoUploadFiles: [],
      uploadRenderKey: 0,
      temp: {
        Id: 0,
        SchId: "",
        CampusId: null,
        ContentType: 1,
        TextContent: "",
        MediaUrl: "",
        ScreenIds: [], // 大屏ID用字符串，避免超大整数精度丢失导致回显失败
        UploaderId: null,
        UploaderName: "",
        UploadSource: 2,
        DisplayOrder: 0,
        IsEnabled: true,
        ContentCategory: 0,
        LicensePlate: "",
        RelatedStudentId: null,
        ViolationLocation: "",
        DisplayUntil: null,
        ExtraRemark: "",
        PublishToScreen: true
      },
      rules: {
        ContentType: [{ required: true, message: "请选择内容类型", trigger: "change" }],
        /** 图片延迟上传时 MediaUrl 为空，需认本地 fileList。最后更新：2026-07-17 */
        MediaUrl: [{
          validator: (rule, value, cb) => {
            if (this.temp.ContentType === 2) {
              cb()
              return
            }
            if (this.temp.ContentType === 1) {
              const files = this.imageUploadFiles || []
              const hasFile = files.length > 0
              const hasLocal = files.some(f => f.raw || (f.url && String(f.url).indexOf('blob:') === 0))
              if (hasFile || hasLocal || (value && String(value).trim())) cb()
              else cb(new Error("请上传图片"))
              return
            }
            if (!value) cb(new Error("请上传或填写媒体地址"))
            else cb()
          },
          trigger: "change"
        }],
        TextContent: [{
          validator: (rule, value, cb) => {
            if (this.temp.ContentCategory === 1) cb();
            else if (this.temp.ContentType === 2 && !value) cb(new Error("请输入文字内容"));
            else cb();
          },
          trigger: "blur"
        }],
        UploaderId: [{
          validator: (rule, value, cb) => {
            if (this.temp.ContentCategory === 1) cb();
            else if (this.temp.Id === 0 && !value) cb(new Error("请选择上传者"));
            else cb();
          },
          trigger: "change"
        }],
        CampusId: [{
          validator: (rule, value, cb) => {
            if (this.temp.Id === 0 && !toDeptId(value)) {
              cb(new Error("请选择校区"));
            } else cb();
          },
          trigger: "change"
        }]
      },
      contentTypeMap: { 1: { label: "图片", type: "success" }, 2: { label: "文字", type: "warning" }, 3: { label: "视频", type: "primary" } },
      auditStatusMap: { 0: { label: "待审核", type: "warning" }, 1: { label: "已通过", type: "success" }, 2: { label: "已拒绝", type: "danger" } },
      auditLoading: false,
      auditRow: null,
      auditAction: 1,
      videoPreviewVisible: false,
      videoPreviewUrl: "",
      /** 车牌反查学生：防抖定时器 */
      plateLookupTimer: null,
      plateLookupLoading: false
    };
  },
  methods: {
    toDeptId,
    /** 切换学校时清空工具栏校区筛选 */
    clearToolbarCampusFilter() {
      this.$set(this.filters, "campusId", null);
      this.$nextTick(() => {
        if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
          this.$refs.toolbar.searchObj.campusId = null;
        }
      });
    },
    treeNodeClick(data) {
      if (data.value == '0') {
        this.$message.warning('请选择具体的学校或校区进行操作');
        this.currentSchId = '';
        this.schoolDepartmentId = '';
        this.campusOptions = [];
        this.syncCampusSearchOptions();
        this.currentDepartmentName = '';
        this.list = [];
        this.clearToolbarCampusFilter();
        return;
      }
      this.currentSchId = treeNodeDeptId(data) || (data.value != null && data.value !== '' ? String(data.value) : '');
      this.schoolDepartmentId = toDeptId(this.currentSchId);
      this.currentDepartmentName = data.label || "";
      this.clearToolbarCampusFilter();
      this.campusOptions = [];
      this.syncCampusSearchOptions();
      if (this.schoolDepartmentId) {
        this.loadCampusOptions();
        this.$nextTick(() => {
          this.handleQuery();
        });
      } else {
        this.syncCampusSearchOptions();
        this.list = [];
      }
    },
    /** 工具栏「选择校区」选项，与 DutyStaff 一致 */
    syncCampusSearchOptions() {
      const campusSearch = this.searchList.find(e => e.key === "campusId");
      if (campusSearch) {
        campusSearch.options = (this.campusOptions || []).map(e => ({
          label: e.Name,
          value: toDeptId(e.Id)
        }));
      }
    },
    /** 工具栏当前选中的校区 Id（字符串），未选返回空。最后修改：2026-10-18 */
    toolbarCampusId() {
      return toDeptId(this.filters && this.filters.campusId);
    },
    loadCampusOptions() {
      if (!this.schoolDepartmentId) return;
      getCampusList({ page: 1, intPageSize: 999, departmentId: this.schoolDepartmentId }).then(res => {
        if (res.data.success && res.data.response) {
          this.campusOptions = res.data.response.data || [];
        } else {
          this.campusOptions = [];
        }
        this.syncCampusSearchOptions();
      }).catch(() => {
        this.campusOptions = [];
        this.syncCampusSearchOptions();
      });
    },
    getCampusName(campusId) {
      if (campusId == null || campusId === "" || campusId === 0) return "-";
      const c = this.campusOptions.find(x => x.Id === campusId);
      return c ? c.Name : String(campusId);
    },
    /** 列表摘要：违停优先车牌，否则截断文案 */
    getListSummary(row) {
      if (!row) return "-";
      if (row.ContentCategory === 1) {
        const plate = row.LicensePlate || "-";
        const stu = row.RelatedStudentName || "";
        return stu ? `车牌 ${plate}｜${stu}` : `车牌 ${plate}`;
      }
      const text = (row.TextContent || "").replace(/\s+/g, " ").trim();
      if (text) return text.length > 40 ? text.slice(0, 40) + "…" : text;
      if (row.ContentType === 1 && row.MediaUrl) return "图片内容";
      return "-";
    },
    handleDetail(row) {
      if (!row) return;
      this.detailRow = { ...row };
      this.detailVisible = true;
    },
    openEditFromDetail() {
      const row = this.detailRow;
      this.detailVisible = false;
      if (row) this.handleEdit(row);
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    getList() {
      if (!this.currentSchId || this.currentSchId === "0") return;
      this.listLoading = true;
      const params = {
        page: this.page,
        intPageSize: this.pageSize,
        schId: this.currentSchId,
        ...this.filters
      };
      if (params.contentCategory === "" || params.contentCategory === null || params.contentCategory === undefined) {
        delete params.contentCategory;
      }
      if (params.contentType === "" || params.contentType === null || params.contentType === undefined) {
        delete params.contentType;
      }
      if (params.auditStatus === "" || params.auditStatus === null || params.auditStatus === undefined) {
        delete params.auditStatus;
      }
      if (params.campusId == null || params.campusId === "" || params.campusId === 0) {
        delete params.campusId;
      }
      getScreenContentList(params)
        .then(async res => {
          if (res.data.success && res.data.response) {
            const resp = res.data.response;
            const rows = resp.data || [];
            await this.prefetchListOssMedia(rows, "MediaUrl");
            this.list = rows;
            this.total = resp.dataCount || 0;
          } else {
            this.list = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.list = [];
          this.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      } else {
        this.filters = {
          contentType: "",
          contentCategory: "",
          auditStatus: "",
          campusId: null
        };
      }
      if (this[item.Func]) this[item.Func].apply(this, item);
    },
    /** 打开违停关联学生通讯录单选。创建于 2026-09-23 */
    openRelatedStudentPicker() {
      if (!this.schoolDepartmentId) {
        this.$message.warning("请先选择左侧学校/机构");
        return;
      }
      this.relatedStudentPickerVisible = true;
    },
    clearRelatedStudent() {
      this.temp.RelatedStudentId = null;
      this.relatedStudentLabel = "";
    },
    onRelatedStudentPicked(person) {
      if (!person) return;
      this.temp.RelatedStudentId = person.id;
      this.relatedStudentLabel = person.name || "";
    },
    /** 弹窗内切换校区时，重拉教师列表 */
    onDialogCampusChange() {
      if (!this.dialogFormVisible) return;
      this.temp.UploaderId = null;
      this.temp.UploaderName = "";
      this.fetchTeachers();
    },
    fetchTeachers() {
      if (!this.currentSchId) return;
      const q = { departmentId: this.currentSchId };
      let cid = '';
      if (this.dialogFormVisible && this.temp && toDeptId(this.temp.CampusId)) {
        cid = toDeptId(this.temp.CampusId);
      } else if (this.toolbarCampusId()) {
        cid = this.toolbarCampusId();
      }
      if (cid) q.campusId = cid;
      getTeacherMasterList(q).then(res => {
        if (res.data && res.data.response) {
          this.teacherOptions = Array.isArray(res.data.response) ? res.data.response : [];
        } else {
          this.teacherOptions = [];
        }
      });
    },
    handleUploaderChange(val) {
      if (val) {
        const t = this.teacherOptions.find(x => x.Id === val);
        if (t) this.temp.UploaderName = t.TeacherName;
      } else {
        this.temp.UploaderName = "";
      }
    },
    resetTemp() {
      const presetCampus = this.toolbarCampusId() || null;
      this.temp = {
        Id: 0,
        SchId: this.currentSchId,
        CampusId: presetCampus,
        ContentType: 1,
        TextContent: "",
        MediaUrl: "",
        ScreenIds: [],
        UploaderId: null,
        UploaderName: "",
        UploadSource: 2,
        DisplayOrder: 0,
        IsEnabled: true,
        ContentCategory: 0,
        LicensePlate: "",
        RelatedStudentId: null,
        ViolationLocation: "",
        DisplayUntil: null,
        ExtraRemark: "",
        PublishToScreen: true
      };
      this.imageUploadFiles = [];
      this.videoUploadFiles = [];
    },
    getUploadResponsePath(res) {
      if (!res || !res.success) return "";
      return (res.response || "").toString();
    },
    toRelativePath(url) {
      if (!url) return "";
      const text = url.toString();
      return text.startsWith(this.BaseApiUrl) ? text.replace(this.BaseApiUrl, "") : text;
    },
    toAbsolutePath(url) {
      if (!url) return "";
      const text = url.toString();
      if (/^https?:\/\//i.test(text)) return text;
      return this.$resolveImageSrc(text);
    },
    getMediaFullUrl(url) {
      return this.toAbsolutePath(url);
    },
    openVideoPreview(url) {
      this.videoPreviewUrl = this.getMediaFullUrl(url);
      this.videoPreviewVisible = true;
    },
    async initUploadFilesByMediaUrl() {
      this.imageUploadFiles = [];
      this.videoUploadFiles = [];
      if (!this.temp.MediaUrl) return;
      if (this.temp.ContentType === 1) {
        this.imageUploadFiles = await this.deferredPictureCardFromMedia([this.temp.MediaUrl]);
      }
      if (this.temp.ContentType === 3) {
        this.videoUploadFiles = [{
          name: this.temp.MediaUrl.split("/").pop(),
          status: "success",
          uid: "video_" + Date.now(),
          url: this.toAbsolutePath(this.temp.MediaUrl),
          response: { response: this.temp.MediaUrl }
        }];
      }
    },
    handleUploadExceed() {
      this.$message.warning("最多上传 1 个文件");
    },
    handleImageChange(file, fileList) {
      this.deferredPictureCardChange(file, fileList, 'imageUploadFiles')
      const path = this.deferredPictureCardItemPath((this.imageUploadFiles || [])[0])
      this.temp.MediaUrl = path || ''
      this.$refs.dataForm && this.$refs.dataForm.validateField('MediaUrl')
    },
    handleImageRemove(file, fileList) {
      this.deferredPictureCardRemove(file, fileList, 'imageUploadFiles')
      if (!fileList.length) this.temp.MediaUrl = ''
    },
    handleVideoUploadSuccess(res, file, fileList) {
      const path = this.getUploadResponsePath(res);
      if (!path) {
        this.$message.error((res && res.msg) || "视频上传失败");
        this.videoUploadFiles = fileList.filter(f => f.uid !== file.uid);
        return;
      }
      this.videoUploadFiles = fileList.slice(-1);
      this.temp.MediaUrl = this.toRelativePath(path);
      this.$refs.dataForm && this.$refs.dataForm.validateField("MediaUrl");
    },
    handleVideoUploadRemove(file, fileList) {
      this.videoUploadFiles = fileList;
      if (!fileList.length) this.temp.MediaUrl = "";
    },
    /** 切换类型时清空图片；保留文字以便「图片+说明」或误切回时少丢字 */
    handleContentTypeChange() {
      this.temp.MediaUrl = "";
      this.deferredPictureCardClear('imageUploadFiles');
      this.videoUploadFiles = [];
    },
    handleContentCategoryChange(val) {
      if (val === 0) {
        this.clearPlateLookupTimer();
        this.temp.LicensePlate = "";
        this.temp.RelatedStudentId = null;
        this.temp.ViolationLocation = "";
        this.temp.DisplayUntil = null;
        this.temp.ExtraRemark = "";
        this.temp.PublishToScreen = true;
        this.relatedStudentLabel = "";
      } else {
        this.temp.PublishToScreen = true;
        this.$nextTick(() => {
          const p = (this.temp.LicensePlate || "").trim();
          if (p.length >= 5) this.runPlateStudentLookup(false);
        });
      }
    },
    clearPlateLookupTimer() {
      if (this.plateLookupTimer) {
        clearTimeout(this.plateLookupTimer);
        this.plateLookupTimer = null;
      }
    },
    /** 输入防抖触发反查 */
    onLicensePlateInput() {
      if (this.temp.ContentCategory !== 1) return;
      this.clearPlateLookupTimer();
      this.plateLookupTimer = setTimeout(() => {
        this.plateLookupTimer = null;
        this.runPlateStudentLookup(false);
      }, 550);
    },
    onLicensePlateBlur() {
      if (this.temp.ContentCategory !== 1) return;
      this.clearPlateLookupTimer();
      this.runPlateStudentLookup(true);
    },
    /**
     * 车牌反查命中后回填关联学生展示名。
     */
    ensureStudentInOptions(studentId, studentName) {
      const id = studentId;
      if (id == null || id === "") return;
      this.temp.RelatedStudentId = id;
      this.relatedStudentLabel = studentName || ("学生#" + id);
    },
    /**
     * 根据车牌在监护人车牌库中反查当前机构学生
     * @param {boolean} fromBlur - 失焦时可为 true，用于无结果时提示（减少输入过程打扰）
     */
    runPlateStudentLookup(fromBlur) {
      if (!this.dialogFormVisible || this.temp.ContentCategory !== 1) return;
      let scopeDeptId = "";
      if (this.temp && toDeptId(this.temp.CampusId)) scopeDeptId = toDeptId(this.temp.CampusId);
      else if (this.toolbarCampusId()) scopeDeptId = this.toolbarCampusId();
      else scopeDeptId = this.currentSchId || "";
      if (!scopeDeptId || scopeDeptId === "0") return;
      const plate = (this.temp.LicensePlate || "").trim();
      if (plate.length < 5) {
        if (fromBlur && plate.length > 0) {
          this.$message.info("车牌过短，请输完整车牌后再试");
        }
        return;
      }
      const plateSent = plate;
      this.plateLookupLoading = true;
      lookupStudentsByPlateForViolation({ schId: scopeDeptId, plate: plateSent })
        .then(res => {
          this.plateLookupLoading = false;
          if (!res.data || !res.data.success) {
            if (res.data && res.data.msg) this.$message.warning(res.data.msg);
            return;
          }
          if ((this.temp.LicensePlate || "").trim() !== plateSent) return;
          const list = res.data.response || [];
          if (list.length === 1) {
            const one = list[0];
            const sid = one.StudentId != null ? one.StudentId : one.studentId;
            const sname = one.StudentName != null ? one.StudentName : one.studentName;
            this.temp.RelatedStudentId = sid;
            this.ensureStudentInOptions(sid, sname);
            if (fromBlur) this.$message.success(`已关联学生：${sname || sid}`);
          } else if (list.length > 1) {
            const names = list.map(x => x.StudentName || x.studentName || "").filter(Boolean).join("、");
            this.$message.warning(`该车牌对应多名学生（${names}），请手动选择关联学生`);
          } else if (fromBlur && plateSent.length >= 6) {
            this.$message.info("未在当前机构下找到绑定该车牌的学生（请先在监护人资料中维护车牌）");
          }
        })
        .catch(() => {
          this.plateLookupLoading = false;
        });
    },
    handleDialogClosed() {
      this.clearPlateLookupTimer();
      this.relatedStudentLabel = "";
      // 关闭后统一重置，避免再次新增时短暂显示上一次上传缩略图
      this.resetTemp();
      this.uploadRenderKey += 1;
      this.$refs.dataForm && this.$refs.dataForm.resetFields();
    },
    handleAdd() {
      if (!this.currentSchId || this.currentSchId === "0") {
        this.$message.warning("请先选择左侧学校/机构");
        return;
      }
      this.resetTemp();
      this.relatedStudentLabel = "";
      this.dialogTitle = "新增展示内容";
      this.dialogFormVisible = true;
      this.fetchTeachers();
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate());
    },
    /** 从已生成文案中还原补充说明。创建于 2026-08-11 */
    extractExtraRemark(text) {
      const raw = text || "";
      const marker = "\n补充说明：";
      const idx = raw.indexOf(marker);
      return idx >= 0 ? raw.slice(idx + marker.length) : "";
    },
    async handleEdit(row) {
      if (!row) {
        this.$message.warning("请选择要编辑的数据");
        return;
      }
      if (row.ContentCategory === 1 && row.AuditStatus === 1) {
        this.$message.warning("已通过的违停登记不可修改，如需撤下请删除");
        return;
      }
      if (row.ContentType === 3) {
        this.$message.warning("当前页面已去掉视频类型，暂不支持编辑视频内容");
        return;
      }
      this.temp = {
        Id: row.Id,
        SchId: row.SchId,
        CampusId: toDeptId(row.CampusId) || null,
        ContentType: row.ContentType,
        TextContent: row.TextContent || "",
        MediaUrl: row.MediaUrl || "",
        // 注意：大屏ID可能超过 JS 安全整数，必须按字符串处理，否则 el-select 无法回显
        ScreenIds: row.ScreenIds ? row.ScreenIds.split(",").map(x => x.trim()).filter(Boolean) : [],
        UploaderId: row.UploaderId,
        UploaderName: row.UploaderName,
        UploadSource: row.UploadSource,
        DisplayOrder: row.DisplayOrder || 0,
        IsEnabled: row.IsEnabled,
        ContentCategory: row.ContentCategory != null ? row.ContentCategory : 0,
        LicensePlate: row.LicensePlate || "",
        RelatedStudentId: row.RelatedStudentId != null ? row.RelatedStudentId : null,
        ViolationLocation: row.ViolationLocation || "",
        DisplayUntil: row.DisplayUntil && row.DisplayUntil !== "0001-01-01T00:00:00" ? this.toPickerDateTime(row.DisplayUntil) : null,
        ExtraRemark: this.extractExtraRemark(row.TextContent),
        PublishToScreen: row.PublishToScreen !== false && row.publishToScreen !== false
      };
      await this.initUploadFilesByMediaUrl();
      this.dialogTitle = "编辑展示内容";
      this.dialogFormVisible = true;
      if (this.schoolDepartmentId) {
        this.loadCampusOptions();
      }
      this.relatedStudentLabel = row.RelatedStudentName || (row.RelatedStudentId ? ("学生#" + row.RelatedStudentId) : "");
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate());
    },
    saveData() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.temp.ContentType === 1) {
            const urls = await this.deferredPictureCardEnsure(this.imageUploadFiles, 'DismissalScreenContentImage')
            this.temp.MediaUrl = urls[0] || ''
            if (!this.temp.MediaUrl) {
              this.submitLoading = false
              this.$message.warning("请上传图片")
              return
            }
          }
          const params = {
            ...this.temp,
            CampusId: toDeptId(this.temp.CampusId) || '',
            ScreenIds: [],
            PublishToScreen: this.temp.PublishToScreen !== false
          };
          if (this.temp.ContentCategory === 1) {
            params.DisplayUntil = null;
            params.TextContent = "";
            params.ExtraRemark = this.temp.ExtraRemark || "";
          }
          saveScreenContent(params)
            .then(res => {
              this.submitLoading = false;
              if (res.data.success) {
                this.$message.success("保存成功");
                this.resetTemp();
                this.uploadRenderKey += 1;
                this.dialogFormVisible = false;
                this.handleQuery();
              } else {
                this.$message.error(res.data.msg || "保存失败");
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    handleDel(row) {
      if (!row) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      const tip = row.ContentCategory === 1
        ? "确认撤下该违停登记吗？已生效的点评/值日扣分不会回滚。"
        : "确认删除该内容吗？";
      this.$confirm(tip, "提示", { type: "warning" }).then(() => {
        deleteScreenContent({ id: row.Id }).then(res => {
          if (res.data.success) {
            this.$message.success("删除成功");
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    handleAudit(row, status) {
      this.auditRow = row;
      this.auditAction = status;
      this.$confirm(`确定${status === 1 ? "通过" : "拒绝"}该内容吗？`, "提示", { type: "warning" })
        .then(() => {
          this.confirmAudit();
        })
        .catch(() => {});
    },
    confirmAudit() {
      if (!this.auditRow) return;
      this.auditLoading = true;
      auditScreenContent({
        Id: this.auditRow.Id,
        AuditStatus: this.auditAction
      })
        .then(res => {
          this.auditLoading = false;
          if (res.data.success) {
            this.$message.success("审核成功");
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || "审核失败");
          }
        })
        .catch(() => {
          this.auditLoading = false;
        });
    },
    formatTime(time) {
      if (!time || time === "0001-01-01T00:00:00") return "";
      const d = new Date(time);
      if (Number.isNaN(d.getTime())) return "";
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    },
    /** 接口返回时间转 el-date-picker value-format 字符串 */
    toPickerDateTime(time) {
      if (!time) return null;
      const d = new Date(time);
      if (Number.isNaN(d.getTime())) return null;
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")}`;
    }
  },
  beforeDestroy() {
    this.clearPlateLookupTimer();
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some(b => b.Func === "handleQuery")) {
      this.buttonList.unshift({ name: "查询", Func: "handleQuery", id: 999 });
    }
    if (!this.buttonList.some(b => b.Func === "handleAdd")) {
      this.buttonList.push({ name: "新增", Func: "handleAdd", id: 998 });
    }
  }
};
</script>

<style scoped>
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.muted-text {
  color: #94a3b8;
}
.form-hint {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}
.form-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.pagination-container {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.detail-section-title {
  margin: 16px 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.detail-media {
  width: 100%;
  min-height: 180px;
  max-height: 320px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-media__img {
  width: 100%;
  height: 280px;
}

.detail-media__img >>> .el-image__inner {
  max-height: 280px;
  object-fit: contain;
}

.detail-text {
  margin-top: 10px;
  padding: 12px 14px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
  color: #303133;
  font-size: 13px;
  max-height: 220px;
  overflow: auto;
}

.detail-text--empty {
  color: #909399;
}

.upload-demo /deep/ .el-upload--picture-card {
  width: 90px;
  height: 90px;
  line-height: 90px;
}

.upload-demo /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 90px;
  height: 90px;
}

.video-preview-wrap {
  margin-top: 10px;
}

.video-preview-title {
  margin-bottom: 6px;
  color: #606266;
  font-size: 13px;
}

.video-preview-player {
  width: 220px !important;
  max-width: 220px !important;
  min-width: 220px;
  height: 124px !important;
  max-height: 124px !important;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #000;
  object-fit: contain;
  display: block;
}

.video-dialog-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.video-dialog-player {
  width: 560px !important;
  max-width: 560px !important;
  min-width: 560px;
  height: 315px !important;
  max-height: 315px !important;
  background: #000;
  border-radius: 6px;
  object-fit: contain;
  display: block;
}

.action-ok {
  color: #67c23a;
}

.action-reject,
.action-del {
  color: #f56c6c;
}

/* 列表行高随内容，避免操作列被固定高度撑出空白 */
.content-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  min-height: 48px;
}

.content-preview--text {
  padding: 6px 10px 6px 8px;
  background: linear-gradient(90deg, #ecf5ff 0%, #f8fbff 100%);
  border: 1px solid #d9ecff;
  border-radius: 8px;
  border-left: 3px solid var(--btn-primary, #2563eb);
}

.content-preview--image {
  padding: 5px 10px 5px 5px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 10px;
}

.content-preview__text-wrap {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.content-preview__type-icon {
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 15px;
  color: var(--btn-primary, #2563eb);
}

.content-preview__text {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #303133;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.content-preview__thumb {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.content-preview__thumb >>> .oss-media-thumbs {
  display: block;
  width: 100%;
  height: 100%;
}

.content-preview__thumb >>> img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  cursor: pointer;
}

.content-preview__meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.content-preview__meta-label {
  font-size: 11px;
  line-height: 1;
  color: #909399;
  letter-spacing: 0.02em;
}

.content-preview__caption {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-preview__meta--placeholder .content-preview__meta-hint {
  font-size: 12px;
  color: #c0c4cc;
  font-style: italic;
}

.content-preview__empty {
  color: #c0c4cc;
  font-size: 13px;
}

.merge-info-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
}

.merge-info-top {
  color: #303133;
  margin-bottom: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.merge-info-bottom {
  color: #909399;
  font-size: 12px;
}
</style>

<!-- tooltip 挂载在 body，需非 scoped -->
<style>
.screen-content-tooltip-popper {
  max-width: 380px;
  line-height: 1.55;
  font-size: 13px;
}

.screen-content-tooltip-popper .content-tooltip-html {
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
}

.screen-content-dialog {
  margin-top: 6vh !important;
}

.screen-content-dialog .el-dialog__body {
  max-height: calc(88vh - 150px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
